module.exports = __webpack_public_path__ + "img/12.dfd6e9e7.png";